<template>
    <div class="selcted">
        <a :href="`/res?search=${res.keywords}`" class="sel_title" target="_blank">
            {{res.select_category_name[0]}}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {{res.select_category_name[1]}}
        </a>
        <div class="sel_block">
            <a class="img_box" v-for="item in info.results"  :href="'/res/' + item.resource" target="_blank">
                <img img :src="item.imgurl">
            </a>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default{
        name: 'SelectedBlock',
        props: ['res'],
        data: function(){
            return{
                info: ''
            }
        },

        mounted(){
            this.getItems()
        },

        methods:{
            getItems:function(){
                let url = '/api/selitem?category=' + this.res.id.toString()
                axios
                    .get(url)
                    .then(response => {
                        this.info = response.data;
                        })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style>
.selcted{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 1280px;
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 128px;
}

.sel_title{
    text-decoration: none;
    width: 1280px;
    font-size: 84px;
    font-weight: lighter;
    color: #45B5B5;
    background-color: rgb(250, 250, 250);
    line-height: 84px;
    border-radius: 5px;
    user-select: none; 
    overflow: hidden;
    text-align: center;
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.sel_title:hover{
    font-size: 96px;
    background-color: rgb(235, 242, 242);
}

.sel_block{
    display: flex;
    width: 1280px;
    margin: 5px 0 0 0;
    gap: 5px;
    overflow: hidden;
    border-radius: 5px;
}

.img_box{
    width: 252px;
    height: 600px;
    overflow: hidden;
    position: relative;
    transition: all 0.3s ease;
    flex-shrink: 0;
    cursor: pointer;
    border-radius: 5px;
}

.img_box:hover {
    width: 450px;
}

.img_box:first-child:hover {
    margin-right: auto;
}

.img_box:last-child:hover {
    margin-left: calc(252px - 450px);
}

.img_box:nth-child(2):hover,
.img_box:nth-child(3):hover,
.img_box:nth-child(4):hover {
    margin-left: auto;
    margin-right: auto; 
}

.sel_block:has(.img_box:last-child:hover) .img_box:not(:last-child) {
    transform: translateX(calc(252px - 450px));
}

.img_box img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    width: auto;
    min-width: 100%;
    user-select: none;
}

</style>